/**
 * Latest Work Smooth Carousel (JS version)
 * This handles dual-direction infinite scroll without using standard CSS keyframe marquees
 * to allow for more control and smoother execution.
 */

class LatestWorkCarousel {
    constructor() {
        this.marquees = document.querySelectorAll('.work-marquee');
        this.init();
    }

    init() {
        this.marquees.forEach(marquee => {
            const track = marquee.querySelector('.work-marquee__track');
            const direction = marquee.classList.contains('work-marquee--ltr') ? 1 : -1;
            this.handleSmoothMarquee(track, direction);
        });
    }

    handleSmoothMarquee(track, direction) {
        let x = 0;
        const speed = 0.5; // Adjust speed here
        let isPaused = false;

        // Clone for seamless loop if needed (PHP already does it, but JS ensures we cover gaps)
        const trackWidth = track.scrollWidth;

        const animate = () => {
            if (!isPaused) {
                x += speed * direction;
                
                // Seamless wrap
                if (direction === 1) { // LTR
                    if (x > 0) x = -trackWidth / 2;
                } else { // RTL
                    if (x < -trackWidth / 2) x = 0;
                }

                track.style.transform = `translateX(${x}px)`;
            }
            requestAnimationFrame(animate);
        };

        // Pause on hover
        marquee.addEventListener('mouseenter', () => isPaused = true);
        marquee.addEventListener('mouseleave', () => isPaused = false);

        requestAnimationFrame(animate);
    }
}

// Optimized simpler approach for CSS with requestAnimationFrame logic
document.addEventListener('DOMContentLoaded', () => {
    const tracks = document.querySelectorAll('.work-marquee__track');
    
    tracks.forEach(track => {
        const marquee = track.closest('.work-marquee');
        let speed = 0.8; // default speed px per frame
        let currentPos = 0;
        const isLTR = marquee.classList.contains('work-marquee--ltr');
        const trackWidth = track.offsetWidth / 2; // Assuming PHP sent 2x content
        let isPaused = false;

        const scroll = () => {
            if (!isPaused) {
                if (isLTR) {
                    currentPos += speed;
                    if (currentPos >= 0) {
                        currentPos = -trackWidth;
                    }
                } else {
                    currentPos -= speed;
                    if (currentPos <= -trackWidth) {
                        currentPos = 0;
                    }
                }
                track.style.transform = `translate3d(${currentPos}px, 0, 0)`;
            }
            requestAnimationFrame(scroll);
        };

        marquee.addEventListener('mouseenter', () => isPaused = true);
        marquee.addEventListener('mouseleave', () => isPaused = false);

        // Position initial LTR to middle so it doesn't jump
        if (isLTR) currentPos = -trackWidth;

        scroll();
    });
});
